export default __webpack_public_path__ + "static/og-image-fed743f51ffc7ffbb81471295803786a.jpg";